<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="نبذة-عن-الكاتب">
<h1><span dir="rtl">نبذة عن الكاتب</span></h1>
<p><em><span dir="rtl">إن فابريس چومون الملقب بـ "عرّاب برامج الدمج اللغوي" من قبل صحيفة نيويورك تايمز في عام 2014، لدية أكثر من 25 عاماً من الخبرة في مجال التعليم الدولي، وفي تطوير برامج متعددة اللغات. وقد وضع خبرته مباشرة في خدمة المجتمعات الفرنسية والإيطالية واليابانية والألمانية والروسية في الولايات المتحدة من خلال مساعدتهم على تطوير برامج ثنائية اللغة ذات جودة عالية في المدارس الحكومية المحلية</span>.</em></p>
<p><em><span dir="rtl">فابريس چومون هو أيضاً مؤلف كتاب ((الشركاء غير المتكافئين: المؤسسات الأمريكية وتنمية التعليم العالي في أفريقيا))، والذي يسلط الضوء على دور العمل الخيري في التعليم، وخاصة تأثير المنظمات الأمريكية على الجامعات في العالم النامي</span>.</em></p>
<p><em><span dir="rtl">فابريس چومون حاصل على درجة الدكتوراه في التعليم الدولي من جامعة نيويورك، يركز بحثه على تقاطع التعليم المقارن والدولي، والعمل الخيري، والدبلوماسية الثقافية، والتنمية الدولية. يعمل فابريس كمسؤول برامج في مؤسسة وكملحق تعليمي لسفارة فرنسا في الولايات المتحدة.</span></em></p>
<p><span dir="rtl"><br/>
</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?1f8bab4c